import { render, staticRenderFns } from "./colaboradores.vue?vue&type=template&id=10dca206&"
import script from "./colaboradores.vue?vue&type=script&lang=js&"
export * from "./colaboradores.vue?vue&type=script&lang=js&"
import style0 from "./colaboradores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports